'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var xhr = _interopDefault(require('xhr'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var Iris = /** @class */ (function () {
    function Iris(_a) {
        var selector = _a.selector, url = _a.url, baseOptions = __rest(_a, ["selector", "url"]);
        var _this = this;
        this.attach = function (node, event, verb, meta) {
            if (meta === void 0) { meta = {}; }
            node.addEventListener(event, function () { return _this.emit(verb, meta); });
        };
        this.defaultMetadata = function () {
            return {
                user_agent: window && window.navigator && window.navigator.userAgent,
                fingerprint: _this.getFingerprint(),
                path: window.location.pathname
            };
        };
        this.getFingerprint = function () {
            return !!_this.fingerprint ? _this.fingerprint : document.cookie.replace(/(?:(?:^|.*;\s*)_afid\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        };
        this.emit = function (verb, metadata) {
            if (metadata === void 0) { metadata = {}; }
            var created_at = new Date().getTime();
            var meta = __assign({}, _this.defaultMetadata(), metadata);
            var _a = _this.baseOptions, source = _a.source, baseOptions = __rest(_a, ["source"]);
            var body = JSON.stringify(__assign({}, baseOptions, { verb: verb, created_at: created_at, meta: meta }));
            var uri = _this.url + "/add/" + source + "/";
            var headers = { 'Content-Type': 'application/json' };
            var xhrOpts = { body: body, uri: uri, headers: headers };
            xhr.post(xhrOpts, function () { return null; });
            // @ts-ignore
            window.DD_LOGS && window.DD_LOGS.logger.info('Iris Event', {
                source: _this.baseOptions.source,
                noun: _this.baseOptions.noun,
                verb: verb
            });
        };
        this.listenToRootRemoval = function (e) {
            if (e.target !== _this.root)
                return;
            // if the root elem is detached, re-attach it
            _this.rootParent.removeEventListener('DOMNodeRemoved', _this.listenToRootRemoval);
            _this.observer.disconnect();
            setTimeout(function () { return _this.attachObserver(); }, 0);
        };
        this.observerCallback = function (mutationRecords) {
            if (!mutationRecords.length)
                return;
            mutationRecords.forEach(_this.attachToAddedNodes);
        };
        this.attachToAddedNodes = function (_a) {
            var addedNodes = _a.addedNodes;
            if (!addedNodes.length)
                return;
            try {
                addedNodes.forEach(_this.attachToIrisNode);
            }
            catch (err) {
                Array.prototype.forEach.call(addedNodes, _this.attachToIrisNode);
            }
        };
        this.attachToIrisNode = function (node) {
            if (_this.checkNodeType(node))
                return;
            var nodes = _this.getIrisElements(node);
            if (!nodes.length)
                return;
            nodes.forEach(_this.attachEventListener);
        };
        this.attachEventListener = function (node) {
            if (!node || !node.getAttributeNames)
                return;
            var _a = _this.parseIrisOptions(node), event = _a.event, verb = _a.verb, meta = _a.meta;
            node.addEventListener(event, function () { return _this.emit(verb, meta); });
        };
        this.url = url;
        this.baseOptions = baseOptions;
        if (selector) {
            this.selector = selector;
            this.setRoot();
            this.watchRootDetachment();
            this.attachToCurrentNodes();
            this.attachObserver();
        }
    }
    Iris.prototype.setFingerprint = function (fingerprint) {
        this.fingerprint = fingerprint;
    };
    Iris.prototype.setRoot = function () {
        this.root = document.querySelector(this.selector);
        if (!this.root)
            throw new Error("Selector " + this.selector + " does not exist.");
        if (this.root.parentElement === null)
            throw new Error("Selector (" + this.selector + ") is not attached to the document");
    };
    Iris.prototype.watchRootDetachment = function () {
        var _this = this;
        // Store the parent reference in case `root` is detached
        this.rootParent = this.root.parentElement;
        this.rootParent.addEventListener('DOMNodeRemoved', function (e) {
            _this.listenToRootRemoval(e);
        });
    };
    Iris.prototype.attachObserver = function () {
        this.observer = new MutationObserver(this.observerCallback);
        this.observer.observe(this.root, { childList: true, subtree: true });
    };
    Iris.prototype.attachToCurrentNodes = function () {
        var currentNodes = this.getIrisElements(this.root) || [];
        Object.keys(currentNodes).map(function (key) { return currentNodes[key]; }).forEach(this.attachEventListener);
    };
    Iris.prototype.checkNodeType = function (node) {
        // return early if undesirable node
        return !(node instanceof HTMLElement) || node instanceof HTMLScriptElement || node instanceof HTMLStyleElement;
    };
    Iris.prototype.getIrisElements = function (node) {
        return node.querySelectorAll('[iris]');
    };
    Iris.prototype.parseIrisOptions = function (node) {
        var irisAttributes = node
            .getAttributeNames()
            .filter(function (attr) { return /^iris-/.test(attr); })
            .map(function (attr) { return attr.replace('iris-', ''); });
        var attributes = irisAttributes.filter(function (attr) { return !/^meta/.test(attr); }).filter(Boolean);
        var metaAttributes = irisAttributes
            .filter(function (attr) { return /^meta/.test(attr); })
            .map(function (attr) { return attr.replace('meta-', ''); })
            .filter(Boolean);
        var options = {};
        var meta = {};
        attributes.map(function (attr) {
            options[attr] = node.getAttribute("iris-" + attr);
            meta[attr] = node.getAttribute("iris-meta-" + attr);
        });
        irisAttributes.forEach(function (attr) { return node.removeAttribute("iris-" + attr); });
        node.removeAttribute('iris');
        return __assign({}, options, { meta: meta });
    };
    return Iris;
}());

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

var _a;
// Use a symbol if available, keep it private
var irisInstance = typeof Symbol === 'function' ? Symbol('iris') : 'iris';
var iris = (_a = {},
    _a[irisInstance] = null,
    _a.init = function (options) {
        // create script element to load the datadog client from cdn
        var loadClientScript = document.createElement('script');
        loadClientScript.type = 'text/javascript';
        loadClientScript.src = 'https://www.datadoghq-browser-agent.com/datadog-logs-us.js';
        // create script to instantiate datadog client
        var instantiateClientScript = document.createElement('script');
        instantiateClientScript.innerHTML = 'window.DD_LOGS && ' +
            'DD_LOGS.init({clientToken: ' +
            '\'' + options.datadog_client_token + '\', forwardErrorsToLogs: false});';
        loadClientScript.onload = function () {
            document.head.appendChild(instantiateClientScript);
        };
        // inject script on to page
        document.head.appendChild(loadClientScript);
        if (this[irisInstance])
            return this[irisInstance];
        // IE10 and below don't support this feature
        if (options.selector && typeof MutationObserver === 'undefined')
            return false;
        // Track distinct anonymous users using the aid cookie.
        // Previously this was the afid cookie
        // retrieve the cookie:
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
        var afid = document.cookie.replace(/(?:(?:^|.*;\s*)aid\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        if (afid === '') {
            afid = document.cookie.replace(/(?:(?:^|.*;\s*)_afid\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        }
        if (afid === '') {
            afid = uuidv4();
            if (window.location.hostname.endsWith("teachable.com")) {
                // TODO: Remove writing _afid cookie once things are stable
                document.cookie = "_afid=" + afid + "; max-age=" + 86400 * 365 + "; path=/; domain=.teachable.com";
                document.cookie = "aid=" + afid + "; max-age=" + 86400 * 365 + "; path=/; domain=.teachable.com";
            }
            else if (window.location.hostname.endsWith("zeachable.cloud")) {
                document.cookie = "aid=" + afid + "; max-age=" + 86400 * 365 + "; path=/; domain=.zeachable.cloud";
            }
            else if (window.location.hostname.endsWith("worksonmy.computer")) {
                document.cookie = "aid=" + afid + "; max-age=" + 86400 * 365 + "; path=/; domain=.worksonmy.computer";
            }
            else {
                document.cookie = "aid=" + afid + "; max-age=" + 86400 * 365 + "; path=/";
            }
        }
        // set the noun_id if none is passed
        if (!options.noun_id) {
            options.noun_id = afid;
        }
        var iris = new Iris(options);
        this[irisInstance] = iris;
        this[irisInstance].setFingerprint(afid);
        window.iris = iris;
        return this[irisInstance];
    },
    _a);

exports.iris = iris;
//# sourceMappingURL=index.js.map
